
<div
  class="c-navigation-panel -responsive"
  :class="{ 'is-visible': isHighlightsPanelVisible }"
>
  <div
    class="c-navigation-panel__content-container"
    @mousedown.prevent
  >
    <div
      class="c-navigation-panel__content"
      :class="{ 'is-visible': isHighlightsPanelVisible }"
    >
      <div class="o-container t-full">
        <div class="o-grid -xs-left -xs-no-gutter t-full">
          <div class="o-grid__item">
            <vSearchHighlightsContent
              :initial-context="initialContext"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
